export const formConfig = {
  email: {
    maxLength: 50,
    regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  },
  dogName: {
    pattern: /^[a-zA-Z]{2,15}$/,
  },
  name: {
    pattern: /^[a-zA-Z]{2,15}$/,
  },
  password: {
    regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,20}$/,
  },
  FirstVisitPage: {
    email: {
      required: true,
    },
  },
};
